import {
    Box,
    Flex,
    Input, InputGroup,
    InputRightElement, Menu,
    MenuButton, MenuItem, MenuList
} from "@chakra-ui/react"
import { SearchIcon } from "@root/assets"
import { DownArrow } from "@root/assets/icons/downArrow"
import { CustomText } from "@root/components/common/components"
import { DateField } from "@root/components/date-field"
import { useState } from "react"
import { useTranslation } from "react-i18next"
export const UserMangementFilters = (props: any) => {
    const {
        inputPlaceholder = '',
        statusPlaceholder = '',
        onInputChange,
        onDateChange,
        onStatusChange,
        userStatuses = [],
        search = '',
        lastLoginDates = [],
        currentStatus = ''
    } = props
    const { t } = useTranslation('common')
    const [startDate, setStartDate] = useState<any>(lastLoginDates?.[0]);
    const [endDate, setEndDate] = useState<any>(lastLoginDates?.[1]);
    const clearDates = () => {
        setStartDate(null);
        setEndDate(null);
        onDateChange(null)
    };

    const handleDateChange = (date: TObject | undefined) => {
        if (Array.isArray(date)) {
            if (date[0]) {
                setStartDate(date[0]);
            } else setStartDate(undefined);
            if (date[1]) {
                setEndDate(date[1]);
            } else setStartDate(undefined);
        }
        onDateChange(date)
    };

    return (
        <Flex
            padding={'16px'}
            gap={'16px'}
            flexDir={{ base: "column", sm: "row" }}
        >
            <InputGroup
                maxW={{ sm: '343px' }}
            >
                <Input
                    value={search}
                    _placeholder={{
                        color: "theme.gray.300"
                    }}
                    placeholder={inputPlaceholder}
                    onChange={onInputChange}
                />
                <InputRightElement>
                    <SearchIcon color={'theme.gray.300'} />
                </InputRightElement>
            </InputGroup>
            <Flex
                gap={'16px'}
            >
                <Box
                    position={'relative'}
                    height={'fit-content'}
                    width={'230px'}
                    >
                    <DateField
                        padding={0}
                        height='52px'
                        placeholder={t('translate.select_last_login_date')}
                        value={startDate && endDate ? [startDate, endDate] : undefined}
                        onChange={handleDateChange}
                        onClear={clearDates}
                        disabled={false}
                        isISO
                        range
                        inputWidth="100%"
                    />
                </Box>
                <Menu>
                    <MenuButton>
                        <InputGroup
                            maxW={{ lg: '240px' }}
                        >
                            <Input
                                _placeholder={{
                                    color: "theme.gray.300"
                                }}
                                placeholder={statusPlaceholder}
                                value={currentStatus}
                            />
                            <InputRightElement>
                                <DownArrow color={'theme.gray.300'} />
                            </InputRightElement>
                        </InputGroup>
                    </MenuButton>
                    <MenuList>
                        {
                            userStatuses?.map((status: string) => (
                                <MenuItem
                                    bgColor={currentStatus === status ? "primary.700" : "transparent"}
                                    onClick={() => onStatusChange(status)}
                                    py={2}
                                    _hover={{ bgColor: "primary.700" }}
                                >
                                    <CustomText
                                        text={status}
                                    />
                                </MenuItem>
                            ))
                        }
                    </MenuList>
                </Menu>
            </Flex>
        </Flex>
    )
}

